import {useEffect} from "react";

export default function useCustomCopy() {
 useEffect(()=>{
   document.addEventListener('copy', (event) => {
     // Получаем выделенный текст
     const selectedText = window.getSelection().toString();

     // Добавляем свой шмурдяк
     const href = window.location.href;
     const newText = `${selectedText} (${href})`;

     // Пихаем в буфер обмена
     event.clipboardData.setData('text/plain', newText);

     // Блокируем стандартное поведение
     event.preventDefault();
   });
 },[])
}
